import { useState, useMemo, useContext, useEffect, useRef } from 'react';
import _ from 'underscore';
import services from '../../../services/services.js';
import { Urls } from '../../../services/Urls.js'
import { callautopopulate } from '../../../services/callautopop.js';
import { ToastContext } from '../../../context/ToastContext.js';
import { useCommon } from '../../Common/useCommon.js';
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { dateHoverRange } from '../../../utils/Helper.js';
import { useLocation } from 'react-router-dom';


export const useReports = () => {
    const { showError, showSuccess, showInfo } = useContext(ToastContext);
    const [html, setHtml] = useState('');
    const [options, setOptions] = useState({ projects: [], sub_projects: [], sprints: [], all_sprints: [], users: [] });
    const [filterValues, setFilterValues] = useState({ project: null, sub_project: [], sprints: null, users: null, status: 'Unverified' });
    const [hoveredRange, setHoveredRange] = useState([]);
    const [reportList, setreportList] = useState([]);
    const [selectedReport, setselectedReport] = useState([]);
    const [loader, setLoader] = useState(false);
    const [listLoader, setlistLoader] = useState(false);
    const [isChanged, setIsChanged] = useState(false);
    const [showPrecisionReport, setShowPrecisionReport] = useState(false);
    const [leadName, setLeadName] = useState([])
    const containerRef = useRef();
    const location = useLocation();
    const [isStatic, setIsStatic] = useState(null)
    const { allSprintList, getProjectSprints, getUserProjects, projectOpts } = useCommon();

    useEffect(() => {
        if (location?.pathname?.includes("static-report")) {
            setreportList([{
                "report_id": 0,
                "report_name": "Precision report",
                "report_key": "precision_report"
            }]);
            setIsStatic(true);
            setHtml("");
        } else {
            getReportList();
            getProjectSprints();
            getUserProjects();
            getSubProjectModule();
            setIsStatic(false);
            setShowPrecisionReport(false);
            setFilterValues({ project: null, sub_project: [], sprints: null, users: null });
        }
        setselectedReport([]);
    }, [location])

    useEffect(() => {
        callautopopulate("users", "user_info").then(res => {
            setOptions((prev) => ({ ...prev, users: _.sortBy(res?.users, "user_display_name") }));
        })
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        setOptions((prev) => ({ ...prev, sprints: allSprintList, all_sprints: allSprintList }));
    }, [allSprintList])

    useEffect(() => {
        setOptions((prev) => ({ ...prev, projects: projectOpts }));
    }, [projectOpts])

    const getReportList = async () => {
        try {
            setlistLoader(true)
            const response = await services.getInvokeRemote('GET', Urls('GETREPORTLIST'))
            if (!_.isEmpty(response)) {
                if (response.body.StatusCode === 400 || response.body.StatusCode === 204 || response.body.StatusCode === 202 || response.body.StatusCode === 401 || response.body.StatusCode === 500) {
                    showError("Error", response.body.errorMessage);
                }
                else if (response?.body?.data?.report_list) {
                    setlistLoader(false)
                    setreportList(_.filter(response.body.data.report_list, item => item?.report_key !== "precision_report"))
                }
            }
        } catch (error) {
            setlistLoader(false)
            console.error(error);
        }
    }
    // this function handle the report html download
    function downloadHtmlFile(htmlContent) {
        const blob = new Blob([htmlContent], { type: 'text/html' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        const projectName = filterValues?.project?.project_name || "report";
        const fromDate = hoveredRange[0] !== undefined ? hoveredRange[0].toDate().toISOString().slice(0, 10) : '';
        const toDate = hoveredRange[0] !== undefined ? hoveredRange[1].toDate().toISOString().slice(0, 10) : '';
        const safeProjectName = projectName.replace(/[^a-zA-Z0-9-_]/g, "_");
        a.download = `${safeProjectName}_${fromDate}_to_${toDate}.html`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    }

    // this function handle the report pdf download
    const downloadPdfFile = async () => {
        const element = containerRef.current;
        const canvas = await html2canvas(element);
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF("portrait", "pt", "a4");
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
        pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
        const projectName = filterValues?.project?.project_name || "report";
        const fromDate = hoveredRange[0] !== undefined ? hoveredRange[0].toDate().toISOString().slice(0, 10) : '';
        const toDate = hoveredRange[0] !== undefined ? hoveredRange[1].toDate().toISOString().slice(0, 10) : '';
        const safeProjectName = projectName.replace(/[^a-zA-Z0-9-_]/g, "_");
        let fileName = `${safeProjectName}_${fromDate}_to_${toDate}.pdf`;
        pdf.save(fileName);
    };

    const handleReport = async (data, key) => {
        if (data?.report_key === "precision_report") {
            setShowPrecisionReport(true);
            setselectedReport(data)
            return;
        } else {
            setShowPrecisionReport(false);
            setLoader(true)
            let payload = {
                "report_id": data?.report_id,
                "project_id": key === 'project' ? 0 : filterValues?.project?.project_id || 0,
                "sub_project_ids": key === "subproject" ? "" : _.pluck(filterValues?.sub_project, "option_id")?.toString() || "",
                "sprint_id": key === 'sprint' ? 0 : filterValues?.sprints?.sprint_id || 0,
                "requested_user_code": key === 'user' ? 0 : filterValues?.users?.user_code || 0,
                "from_date": hoveredRange?.[0] !== undefined ? hoveredRange[0].toDate().toISOString().slice(0, 10) : '',
                "to_date": hoveredRange?.[0] !== undefined ? hoveredRange[1].toDate().toISOString().slice(0, 10) : '',
            }
            setselectedReport(data)
            try {
                const response = await services.getInvokeRemote('POST', Urls('GETREPORTDESCRIPTION'), payload)
                if (!_.isEmpty(response)) {
                    setLoader(false)
                    if (response.body.StatusCode === 400 || response.body.StatusCode === 204 || response.body.StatusCode === 202 || response.body.StatusCode === 401 || response.body.StatusCode === 500) {
                        showError("Error", response.body.errorMessage);
                    }
                    else if (response?.body?.data?.report_description) {
                        const data = response.body.data?.report_description[0]
                        setHtml(data?.htmltext);
                        setLeadName(data?.project_lead_name)
                        setFilterValues((prev) => ({ ...prev, status: data?.verified }))
                    }
                    setIsChanged(false);
                }
            }
            catch (error) {
                setLoader(false)
                console.error(error)
                setIsChanged(false);
            }
        }
    }


    const handleProject = (e) => {
        setFilterValues((prev) => ({ ...prev, project: e }))
        if (!_.isEmpty(e)) {
            const currentSelectedProjSprint = _.where(options?.all_sprints, { 'project_id': e?.project_id })
            setOptions((prev) => ({ ...prev, sprints: currentSelectedProjSprint }));
            setFilterValues((prev) => ({ ...prev, sprints: _.findWhere(currentSelectedProjSprint, { sprint_id: filterValues?.sprints?.sprint_id }) }))
        }
        if (e === undefined) {
            setIsChanged(false)
            setOptions((prev) => ({ ...prev, sprints: options?.all_sprints }));
            handleReport(selectedReport, 'project')
        }
        getSubProjectModule(e)
    }

    const getSubProjectModule = async (project) => {
        const payload = {
            "project_ids": project ? project?.project_id?.toString() : ""
        }
        try {
            const res = await services.getInvokeRemote('POST', Urls('GETSUBPROJECT'), payload);
            if (res) {
                const data = res.body.data.sub_project;
                setOptions((prev) => ({ ...prev, sub_projects: _.sortBy(data, 'option_value') }));
                setFilterValues((prev) => ({ ...prev, sub_project: _.filter(data, item => _.pluck(filterValues?.sub_project, "option_id")?.includes(item?.option_id)) }));
            }
        }
        catch (error) {
            console.error(error, "error");
        }

    }

    const handleCancelCalendar = () => {
        setHoveredRange([])
    }

    function MyPlugin({ position }) {
        if (position === 'bottom') {
            return (
                <div className="weeks ">
                    <div>
                        <button onClick={handleCancelCalendar} className="cancel-calendar">
                            Cancel
                        </button>
                    </div>
                </div>
            );
        }
    }

    const handleSprint = (e) => {
        setFilterValues((prev) => ({ ...prev, sprints: e }));
        if (e === undefined) {
            handleReport(selectedReport, 'sprint')
        }
    }

    const handleUser = (e) => {
        setFilterValues((prev) => ({ ...prev, users: e }))
        if (e === undefined) {
            handleReport(selectedReport, 'user')
        }
    }

    const handleMail = async (html) => {
        try {
            const payload = {
                "project_lead_name": leadName,
                "html_body": html,
                "from_date": hoveredRange?.[0] !== undefined ? dateHoverRange(hoveredRange[0]) : '',
                "to_date": hoveredRange?.[1] !== undefined ? dateHoverRange(hoveredRange[1]) : ''
            }
            const res = await services.getInvokeRemote("POST", Urls("BIWEEKLYEMAILSENT"), payload)
            if (!res?.body?.error_status) {
                showSuccess("success", res?.body?.message);
            } else {
                showError("error", res?.body?.errorMessage);
            }
        } catch (error) {
            console.error(error)
        }
    }

    const verifyReport = async () => {
        try {
          
            let payload = {
                "project_id": filterValues?.project?.project_id || 0,
                "from_date": hoveredRange?.[0] !== undefined ? hoveredRange[0].toDate().toISOString().slice(0, 10) : '',
                "to_date": hoveredRange?.[1] !== undefined ? hoveredRange[1].toDate().toISOString().slice(0, 10) : '',
                "is_verified": true
            }
            const todayStr = new Date().toISOString().slice(0, 10);
            if (payload.to_date > todayStr) {
                payload.is_verified = false;
                showInfo("info", "Future dates are not allowed.");
                return;

            }
            const res = await services.getInvokeRemote("POST", Urls("SAVEREPORTVERIFYDETAILS"), payload)
            if (!res?.body?.error_status) {
                showSuccess("success", res?.body?.message);
                setFilterValues((prev) => ({ ...prev, status: "Verified" }))
            } else {
                showError("error", res?.body?.errorMessage);
            }
        } catch (error) {
            console.error(error)
        }
    }

    return useMemo(() => ({
        listLoader, reportList, handleReport, selectedReport, html, loader, MyPlugin, handleProject, handleSprint, handleUser, hoveredRange, setHoveredRange, isChanged, setIsChanged, downloadHtmlFile, downloadPdfFile, containerRef, showPrecisionReport, handleMail, isStatic, options, filterValues, setFilterValues, verifyReport
    }), [listLoader, reportList, handleReport, selectedReport, html, loader, MyPlugin, handleProject, handleSprint, handleUser, hoveredRange, setHoveredRange, isChanged, setIsChanged, downloadHtmlFile, downloadPdfFile, containerRef, showPrecisionReport, handleMail, isStatic, options, filterValues, setFilterValues, verifyReport])
}